let pageMixin = {
  data () {
    return {
      page: {
        page: 1,
        pageSize: 10,
      },
      count: 0
    }
  },
  methods: {
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.page.page = 1;
      this.getList()
    },
    handleCurrentChange (page) {
      this.page.page = page;
      this.getList()
    }
  }
};

export default pageMixin
